export const LLM_MODELS = [
  { key: 'gpt-5.3-codex', name: 'GPT 5.3 Codex', provider: 'AvalAI', badge: 'متوسط' },
  // { key: 'gpt-5.3-codex', name: 'GPT 5.3 Codex', provider: 'GapGPT', badge: 'عالی' },
  { key: 'gpt-5.1-codex-mini', name: 'Codex Mini 5.1', provider: 'AvalAI', badge: 'اقتصادی' },
  { key: 'gpt-5.5', name: 'GPT-5.5', provider: 'AvalAI', badge: 'حرفه ای' }
];

export const DEFAULT_LLM_MODEL_KEY = 'gpt-5.3-codex';

export const getLlmModelsForProvider = (providerKey, models = LLM_MODELS) =>
  models.filter((model) => model.provider === providerKey);

export const getDefaultLlmModelForProvider = (providerKey, models = LLM_MODELS) =>
  getLlmModelsForProvider(providerKey, models)[0]?.key || DEFAULT_LLM_MODEL_KEY;

export const getLlmModelByKey = (key, models = LLM_MODELS) =>
  models.find((model) => model.key === key) || models[0];

export const getLlmModelBadgeByKey = (key, models = LLM_MODELS) => getLlmModelByKey(key, models)?.badge || '';
